module.exports = __webpack_public_path__ + "static/media/tag_faces.d4fe1289.svg";